import { reportException } from '@comeon/error-reporter';
import { ErrorReporterDomain } from '../../../error-handling/error-reporter-domain';

export default function reportSportsbookError<TError extends Error>(
	message: string,
	error: TError | unknown,
	options?: { [key: string]: string }
) {
	reportException(new Error(message, { cause: error }), {
		domain: ErrorReporterDomain.SPORTSBOOK,
		extra: options
	});
}
